import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 87EE041D-81D2-4F1A-A757-F76E9D8686EF
 * name plus-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-box.svg
 * tags
 * - Math 
 */
export const PlusBoxIcon = createSvgIcon(<><path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></>, 'PlusBoxIcon');
export default PlusBoxIcon